import { useEffect } from "react";
import { CookiesProvider } from "react-cookie";
import AuthProvider from "react-auth-kit";
import store from "./Utils/auth/store";
import SessionGate from "./Utils/auth/SessionGate";
import SideBarProvider from "./Context/SideBarProvider";
import RtlProvider from "./Context/RtlProvider";
import SearchProvider from "./Context/SearchProvider";
import ManageRoute from "./ManageRoute";
import TimeZoneProvider from "./Context/TimeZone";
import React from "react";
import { SystemThemeProvider } from "./hooks/useTheme";

function App() {
  return (
    <SystemThemeProvider>
      <RtlProvider>
        <AuthProvider store={store}>
          <SessionGate>
          <SearchProvider>
            <TimeZoneProvider>
              <SideBarProvider>
                <CookiesProvider>
                  <ManageRoute />
                </CookiesProvider>
              </SideBarProvider>
            </TimeZoneProvider>
          </SearchProvider>
          </SessionGate>
        </AuthProvider>
      </RtlProvider>
    </SystemThemeProvider>
  );
}

export default App;
